import type { SvgIconComponent } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/CheckRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import CancelIcon from "@mui/icons-material/ContentPasteOffRounded";
import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import RevertIcon from "@mui/icons-material/ReplayRounded";
import { Button, Tooltip } from "@mui/material";
import type { WorkflowSignalType } from "@entrilia/shared/api/workflowTypes";
import { autoFormatCamelCase } from "@entrilia/shared/utilities/stringHelper";
import { workflowSignalTypeMap } from "../../../utilities/enumCaptions";

interface Props {
  signalType: WorkflowSignalType;
  loading?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  onClick: (signalType: WorkflowSignalType) => void;
}

const workflowSignalTypeIconMap: Record<WorkflowSignalType, SvgIconComponent> = {
  Approve: CheckIcon,
  Reject: CloseIcon,
  Cancel: CancelIcon,
  CreateInvoiceTransaction: CheckIcon,
  SubmitInvoiceWithoutConfiguredApproval: CheckIcon,
  SubmitInvoiceForApproval: CheckIcon,
  DeleteInvoice: DeleteIcon,
  ReturnInvoiceToDraft: RevertIcon,
  BusinessCentralTransactionPosted: CheckIcon,
};

const WorkflowSignalTypeButtonIcon = ({ signalType }: { signalType: WorkflowSignalType }) => {
  const Icon = workflowSignalTypeIconMap[signalType] ?? CheckIcon;
  return <Icon />;
};

const WorkflowSignalActionButton = ({ signalType, loading, disabled, disabledReason, onClick }: Props) => {
  const signalAttributes = workflowSignalTypeMap.get(signalType);

  return (
    <Tooltip title={disabled ? disabledReason : undefined}>
      <span>
        <Button
          variant="outlined"
          color={signalAttributes?.color || "secondary"}
          loading={loading}
          onClick={() => onClick(signalType)}
          disabled={disabled}
          startIcon={<WorkflowSignalTypeButtonIcon signalType={signalType} />}
          sx={{ whiteSpace: "nowrap", minWidth: "6rem" }}
        >
          {signalAttributes?.caption || autoFormatCamelCase(signalType)}
        </Button>
      </span>
    </Tooltip>
  );
};

export default WorkflowSignalActionButton;
